var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"headline mb-6",attrs:{"no-gutters":"","id":_vm.anchor}},[_c('span',{staticClass:"text-h5 text-uppercase"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }